module.exports = __webpack_public_path__ + "static/seranpark-72c516ae6fa46c49998b83fe262d1245.jpeg";